  var Shopify = Shopify || {};
  // ---------------------------------------------------------------------------
  // Money format handler
  // ---------------------------------------------------------------------------
  Shopify.money_format = "${{amount}}";
  Shopify.formatMoney = function(cents, format) {
    if (typeof cents == 'string') { cents = cents.replace('.',''); }
    var value = '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = (format || this.money_format);
    
    function defaultOption(opt, def) {
    return (typeof opt == 'undefined' ? def : opt);
    }
    
    function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ',');
    decimal   = defaultOption(decimal, '.');
    
    if (isNaN(number) || number == null) { return 0; }
    
    number = (number/100.0).toFixed(precision);
    
    var parts   = number.split('.'),
        dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
        cents   = parts[1] ? (decimal + parts[1]) : '';
    
    return dollars + cents;
    }
    
    switch(formatString.match(placeholderRegex)[1]) {
    case 'amount':
      value = formatWithDelimiters(cents, 2);
      break;
    case 'amount_no_decimals':
      value = formatWithDelimiters(cents, 0);
      break;
    case 'amount_with_comma_separator':
      value = formatWithDelimiters(cents, 2, '.', ',');
      break;
    case 'amount_no_decimals_with_comma_separator':
      value = formatWithDelimiters(cents, 0, '.', ',');
      break;
    }
    
    return formatString.replace(placeholderRegex, value);
  };

function initAnnouncementBarSwiper() {
  if (window.innerWidth <= 1080) {
    if (!document.querySelector('.announcement-bar-contnet').classList.contains('swiper-initialized')) {
      new Swiper('.announcement-bar-contnet', {
        loop: true,
        slidesPerView: 1,
        spaceBetween: 10
      });
    }
  }
}
window.addEventListener('load', initAnnouncementBarSwiper);
window.addEventListener('resize', initAnnouncementBarSwiper);


// let items = document.querySelector(".header__inline-menu").querySelectorAll("details") || null;
// if(items){
//     items.forEach(item => {
//      item.addEventListener("mouseover", () => {
//       item.setAttribute("open", true);
//        item.querySelector("ul, .megamenu-image-block.mega_menu_2").addEventListener("mouseleave", () => {
//          item.removeAttribute("open");
//        });
//        item.addEventListener("mouseleave", () => {
//          item.removeAttribute("open");
//        });
//      });
//     });
// }


let tabDetailsSliderInstance = null;

function TabDetailsSlider(activeTab) {
  if (tabDetailsSliderInstance) {
    tabDetailsSliderInstance.destroy(true, true);
  }

  const sliderEl = activeTab.querySelector('.tabdetails-slider');
  const scrollbarEl = activeTab.querySelector('.swiper-scrollbar');

  if (!sliderEl || !scrollbarEl) return;
  tabDetailsSliderInstance = new Swiper(sliderEl, {
    loop: false,
    slidesPerView: 3,
    spaceBetween: 16,
    scrollbar: {
      el: scrollbarEl,
      draggable: true,
    },
    breakpoints: {
      0: {
        slidesPerView: 1.2, 
      },
      750: {
        slidesPerView: 2,
      },
      1080: {
        slidesPerView: 3,
      }
    }
  });
}
const tabButtons = document.querySelectorAll('.tab-button');
const tabContents = document.querySelectorAll('.tab-content');
tabButtons.forEach(button => {
  button.addEventListener('click', () => {
    const tabName = button.dataset.name;

    tabButtons.forEach(btn => btn.classList.remove('active'));
    tabContents.forEach(tab => tab.classList.remove('active'));

    button.classList.add('active');
    const activeTab = document.querySelector(`.tab-content[tab-details="${tabName}"]`);
    if (activeTab) {
      activeTab.classList.add('active');

      if (activeTab.querySelector('.tabdetails-slider')) {
        TabDetailsSlider(activeTab);
      }
    }
  });
});

if (tabButtons.length) {
  tabButtons[0].click();
}


// const gridButton = document.querySelector('.gird-view-block');
// const listButton = document.querySelector('.list-view-block');
// const collectionGrid = document.querySelector('.collection-pdp-grid');

// if (gridButton && listButton && collectionGrid) {
//   gridButton.addEventListener('click', () => {
//     collectionGrid.classList.add('gird-view-active');
//     collectionGrid.classList.remove('list-view-active');
//     gridButton.classList.add('active');
//     listButton.classList.remove('active');
//   });

//   listButton.addEventListener('click', () => {
//     collectionGrid.classList.add('list-view-active');
//     collectionGrid.classList.remove('gird-view-active');
//     gridButton.classList.remove('active');
//     listButton.classList.add('active');
//   }); 
// }

// document.addEventListener('DOMContentLoaded', () => {
//   const dropdown = document.querySelector('.custom-pc-dropdown');

//   if (!dropdown) return;

//   const title = dropdown.querySelector('.custom-dropdown-title');
//   const items = dropdown.querySelectorAll('ul li a');

//   title?.addEventListener('click', (e) => {
//     e.stopPropagation();
//     dropdown.classList.toggle('open');
//   });

//   items.forEach((item) => {
//     item.addEventListener('click', (e) => {
//       e.preventDefault();
//       title.textContent = item.textContent.trim();
//       dropdown.classList.remove('open');

//       // window.location.href = item.getAttribute('href');
//       const limit = item.getAttribute('data-val');
//       const url = new URL(window.location.href);
//       url.searchParams.set('view', limit);
//       window.location.href = url.toString();

//     });
//   });

//   document.addEventListener('click', (e) => {
//     if (!dropdown.contains(e.target)) {
//       dropdown.classList.remove('open');
//     }
//   });
// });


document.addEventListener('DOMContentLoaded', function () {
  const selectBlocks = document.querySelectorAll('.color-block');

  if (selectBlocks.length === 0) return; // exit early if no blocks

  selectBlocks.forEach(block => {
    const select = block.querySelector('.options-name-list');
    const spans = block.querySelectorAll('.color-options span');

    if (!select || spans.length === 0) return;

    const updateSelectedClass = (selectedValue) => {
      spans.forEach(span => {
        span.classList.toggle('selected', span.getAttribute('data-value') === selectedValue);
      });
    };

    // Initial sync
    updateSelectedClass(select.value);

    // On change
    select.addEventListener('change', () => {
      updateSelectedClass(select.value);
    });
  });
  
});

// PDP color Custom popup
document.addEventListener('DOMContentLoaded', function () {
  const buttons = document.querySelectorAll('.viewall-options-popup-button');
  const popups = document.querySelectorAll('.fabrics-color-popup');
  const overlay = document.querySelector('.overlay');
  const closeButtons = document.querySelectorAll('.popup-close-icon');

  if (!buttons.length || !popups.length || !overlay) return;

  buttons.forEach(button => {
    button.addEventListener('click', function () {
      const popupValue = button.getAttribute('data-poppu-button');
      console.log("popupValue:--",popupValue);

      popups.forEach(popup => {
        popup.classList.remove('active'); 
        if (popup.getAttribute('data-poppu-name') === popupValue) {
          popup.classList.add('active');
        }
      });

      overlay.classList.add('active');
      document.body.classList.add('custom-popup-open');
    });
  });

  closeButtons.forEach(close => {
    close.addEventListener('click', function () {
      popups.forEach(popup => popup.classList.remove('active'));
      overlay.classList.remove('active');
      document.body.classList.remove('custom-popup-open');
    });
  });

  overlay.addEventListener('click', function () {
    popups.forEach(popup => popup.classList.remove('active'));
    overlay.classList.remove('active');
    document.body.classList.remove('custom-popup-open');
  });
});






document.addEventListener("DOMContentLoaded", function () {
  const accordions = document.querySelectorAll(".accordion details");

  accordions.forEach((accordion) => {
    accordion.addEventListener("toggle", function () {
      if (accordion.open) {
        accordions.forEach((otherAccordion) => {
          if (otherAccordion !== accordion) {
            otherAccordion.removeAttribute("open");
          }
        });
      }
    });
  });
});



// ak custom code
document.addEventListener("DOMContentLoaded", function () {

  document.getElementById("applyDiscount")?.addEventListener("click", async () => {
    let couponCode = document.getElementById("cart-discount")?.value || '';
    dataLayer.push({
      event: 'coupon_offers_list_checkout',
      additional_attribute: couponCode
    });
  });


  //search category
  document.querySelectorAll('.category-search-dropdown').forEach(function(dropdown) {
    const dropdownList = dropdown.querySelector('.custom-dropdown-list');
    const titleSpan = dropdown.querySelector('.opt_title');
    const inputHidden = document.querySelector('#product_type_input');
    const searchInput = document.querySelector('input[type="search"]'); // Adjust selector if needed

    // Toggle dropdown
    dropdown.querySelector('.trigger_search_pro_type')?.addEventListener('click', () => {
      dropdownList.classList.toggle('active');
    });

    // Handle option click
    dropdownList.querySelectorAll('.custom-select__option.js-option').forEach(option => {
      option.addEventListener('click', () => {
        const selectedText = option.textContent.trim();
        const selectedValue = option.getAttribute('data-value');
  
        // Update text
        titleSpan.textContent = selectedText;
        dropdownList.classList.remove('active');
  
        if (inputHidden) {
          inputHidden.value = selectedValue;
        }
  
        if (searchInput) {
          searchInput.focus();
          searchInput.dispatchEvent(new Event('input'));
        }
      });
    });
    
  });

  //PDP check prices for extra colors
  function check_prices(){
    console.log('hiii get it')

    let totalPrice = 0;
    document.querySelectorAll('.metafiled-color-block select.options-name-list').forEach(function(select_dropdown) {
      const selectedOption = select_dropdown.options[select_dropdown.selectedIndex];
      const price = parseFloat(selectedOption.getAttribute('data-price')) || 0;
      totalPrice += price;
    });

    const productForm = document.querySelector('product-form form');
    if (!productForm) return;

    let hiddenInput = productForm.querySelector('#addon_price');

    if (totalPrice > 0) {
      if (!hiddenInput) {
        hiddenInput = document.createElement('input');
        hiddenInput.type = 'hidden';
        hiddenInput.id = 'addon_price';
        hiddenInput.name = 'properties[_addon_price]';
        productForm.appendChild(hiddenInput);
      }
      hiddenInput.value = totalPrice.toFixed(2);
    } else {
      if (hiddenInput) {
        hiddenInput.remove();
      }
    }


    // Get base price from hidden input
    const variantPriceInput = document.querySelector('#variant_price');
    let basePriceCents = parseInt(variantPriceInput.value, 10) || 0;

    // Add addon price (converted to cents)
    let newTotalPriceCents = basePriceCents + Math.round(totalPrice * 100);

    // Convert to Shopify money format
    const formattedPrice = Shopify.formatMoney(newTotalPriceCents, '${{amount}}')
    // const formattedPrice = (newTotalPriceCents / 100).toLocaleString('en-US', {
    //   style: 'currency',
    //   currency: 'USD'
    // });

    // Update price display
    const priceEl = document.querySelector('.price__regular .price-item.price-item--regular');
    if (priceEl) {
      priceEl.textContent = formattedPrice;
    }

  }

  if(document.body.classList.contains('template-product')){
    check_prices();
  }

  //pdp fabric swatch click
  document.querySelectorAll('.metafiled-color-block .color-options .color-option').forEach(function(color_option) {
    color_option.addEventListener('click',function(){
      const all_fabric = this.closest('.color-options').querySelectorAll('.color-option');
      all_fabric.forEach(function(fabric_swatch){
        fabric_swatch.classList.remove('selected');
      });

      this.classList.add('selected');

      const selected_val = this.getAttribute('data-title').trim();
      const selected_val_handle = this.getAttribute('data-value');

      const fabric_popup_name = this.closest('.color-options').querySelector('.viewall-options-popup-button').getAttribute('data-poppu-button');
      if(fabric_popup_name){
        const main_fabric_popup = document.querySelector('.fabrics-color-popup[data-poppu-name="'+fabric_popup_name+'"]');
        if(main_fabric_popup){
          const selected_find = main_fabric_popup.querySelector('.popup-colorbox[data-value="'+selected_val_handle+'"]');
          if(selected_find){
            selected_find.click();
          }
        }
      }

      const select_dropdown = this.closest('.metafiled-color-block').querySelector('select.options-name-list');      
      if(select_dropdown){
        const select_options = select_dropdown.querySelectorAll('option');
        select_options.forEach(function(option){
          option.removeAttribute('selected');
        });

        // const select_op = select_dropdown.querySelector('option[data-value="'+selected_val_handle+'"]');
        // if(select_op){
        //   select_op.setAttribute('selected','selected');
        // }

        const select_op = select_dropdown.querySelector('option[data-value="'+selected_val_handle+'"]');
        if (select_op) {
          select_op.setAttribute('selected', 'selected');

          // Ensure the select element reflects the change
          select_dropdown.value = select_op.value;

          // Trigger change event
          const event = new Event('change', { bubbles: true });
          select_dropdown.dispatchEvent(event);
        }

      }

      const fabric_popup = this.closest('.color-options').querySelector('.viewall-options-popup-button');
      if(fabric_popup){
        fabric_popup.click();
      }
    });
  });


  document.querySelectorAll('.metafiled-color-block select.options-name-list').forEach(function(select_dropdown) {
    select_dropdown.addEventListener('change',function(){
      check_prices();
    });
  });


  //swatch popup color click
  document.querySelectorAll('.fabrics-color-popup .popup-wrap .right-col .popup-colorbox').forEach(function(color_option) {
    color_option.addEventListener('click',function(){
      const all_fabric = this.closest('.right-col').querySelectorAll('.popup-colorbox');
      all_fabric.forEach(function(fabric_swatch){
        fabric_swatch.classList.remove('active');
      });

      this.classList.add('active');

      const img_url = this.getAttribute('data-image');
      const color_title = this.getAttribute('data-title');

      const left_image = this.closest('.popup-col-wrap').querySelector('.left-col .col-image-wrap img');
      if(left_image){
        left_image.setAttribute('src',img_url);
        left_image.setAttribute('srcset',img_url);
      }

      const left_title = this.closest('.popup-col-wrap').querySelector('.left-col .popup-content .popup-image-title');
      if(left_title){
        left_title.textContent = color_title;
      }

    });
  });

  //save selected btn
  document.querySelectorAll('.fabrics-color-popup').forEach(function(fabric_popup) {
    const save_btn = fabric_popup.querySelector('.popup-wrap .left-col .popup-content .popup-selectButton');
    if(save_btn){
      save_btn.addEventListener('click',function(){      
        
        const selected_val =  this.closest('.popup-col-wrap').querySelector('.right-col .popup-colorbox.active');        
        if(selected_val){
          const select_val_handle = selected_val.getAttribute('data-value');
          const popup_name = fabric_popup.getAttribute('data-poppu-name');
          const swatch_div = document.querySelector('.metafiled-color-block[data-popup-name="'+popup_name+'"]');

          if(swatch_div){
            const select_dropdown = swatch_div.querySelector('select.options-name-list');      
            if(select_dropdown){
              const select_options = select_dropdown.querySelectorAll('option');
              select_options.forEach(function(option){
                option.removeAttribute('selected');
              });

              const select_op = select_dropdown.querySelector('option[data-value="'+select_val_handle+'"]');
              if(select_op){
                select_op.setAttribute('selected','selected');
              }
            }

            const select_color_box = swatch_div.querySelector('.color-options .color-option[data-value="'+select_val_handle+'"]'); 
            if(select_color_box){
              const all_fabric = swatch_div.querySelectorAll('.color-options .color-option');
              all_fabric.forEach(function(fabric_swatch){
                fabric_swatch.classList.remove('selected');
              });

              select_color_box.classList.add('selected');
            }

            

            //close popup 
            const close_btn = fabric_popup.querySelector('.popup-close-icon');
            if(close_btn){
              close_btn.click();
            }
          }
        }
      });
    }
  });



  

//draft order
// const checkout_btn = document.querySelector('button[name="checkout"]');

// if (checkout_btn) {
// checkout_btn.addEventListener("click", async function (e) {
//   e.preventDefault();
//   e.stopPropagation();
  
//   checkout_btn.setAttribute('aria-disabled', true);
//   checkout_btn.classList.add('loading');
//   checkout_btn.querySelector('.loading__spinner').classList.remove('hidden');
//   creatDraftOrder(e);
// });
// }

document.addEventListener('click', async function (e) {

  const checkout_btn = e.target.closest('a[name="checkout"]');
  if (!checkout_btn) return;

  e.preventDefault();
  e.stopPropagation();

  checkout_btn.setAttribute('aria-disabled', true);
  checkout_btn.classList.add('loading');

  const spinner = checkout_btn.querySelector('.loading__spinner');
  if (spinner) spinner.classList.remove('hidden');

  // await creatDraftOrder(e);
     try {

    // Get cart data
    const cartRes = await fetch('/cart.js');
    const cart = await cartRes.json();

    // Check if any cart item has `_addon_price` property
    const hasAddonPrice = cart.items.some(item => {
      return item.properties && item.properties._addon_price;
    });

    // If addon price exists → create draft order
    if (hasAddonPrice) {

      // checkout_btn.setAttribute('aria-disabled', true);
      // checkout_btn.classList.add('loading');

      // const spinner = checkout_btn.querySelector('.loading__spinner');
      // if (spinner) spinner.classList.remove('hidden');

      await creatDraftOrder(e);

    } else {

      // Otherwise trigger sibling checkout button click
      const siblingBtn = checkout_btn.parentElement?.querySelector(
        'button[name="checkout"], input[name="checkout"]'
      );

      if (siblingBtn) {
        siblingBtn.click();
      }
    }

  } catch (error) {
    console.error('Cart check error:', error);
  }

});

async function getCurrentCartJson() {
  try {
    const response = await fetch(`${routes.cart_url}.js`);
    if (!response.ok) {
      const errorText = await response.text();
      return null;
    }
    const cartData = await response.json();
    return cartData;
  } catch (error) {
    console.error('Error fetching cart json:', error);
    return null;
  }
}


function creatDraftOrder(event) {
  event.preventDefault();

  getCurrentCartJson()
    .then(cart => {
      if (cart) {
        //console.log('Current Cart JSON:', cart);
        const filteredItems = [];

      const lineItems = cart.items.map((item) => {
        const customAttributes = [];
        let addonPrice = 0;

        if (item.properties) {
          for (const key in item.properties) {
            const value = item.properties[key];
            if (value !== null && value !== "") {
              customAttributes.push({ key, value });

              if (key.toLowerCase() === "_addon_price") {
                const parsed = parseFloat(value);
                if (!isNaN(parsed)) addonPrice = parsed;
              }
            }
          }
        }

        const baseItemPrice = (item.final_line_price / item.quantity) / 100;
        const finalAmount = baseItemPrice + addonPrice;

        return {
          quantity: item.quantity,
          amount: finalAmount,
          currency_code: Shopify.currency?.active || "USD",
          sku: item.sku || "",
          variantId: item.variant_id,
          customAttributes,
        };
      });

     
      const cartCustomAttributes = [];
      if (cart.attributes) {
        for (const key in cart.attributes) {
          const value = cart.attributes[key];
          if (value) cartCustomAttributes.push({ key, value });
        }
      }
      if (cart.note) cartCustomAttributes.push({ key: "note", value: cart.note });

        
        const payload = {
          lineItems,
          customAttributes: cartCustomAttributes,
        };
  
        const myHeaders = new Headers();
        myHeaders.append("Content-Type", "application/json");


        const requestOptions = {
          method: "POST", // Change GET to POST
          headers: myHeaders,
          body: JSON.stringify(payload),
          redirect: "follow"
        };

        const draftOrderId = localStorage.getItem('draft_order_id');
        callDraftOrderAPI(draftOrderId,requestOptions)
      } else {
        console.log('Could not retrieve cart data.');
        checkout_btn.classList.remove('loading');
        checkout_btn.removeAttribute('aria-disabled');
        checkout_btn.querySelector('.loading__spinner').classList.add('hidden');
      }
    });
}



function callDraftOrderAPI(id,data) {
  let url = `https://dddemo.net/php/2025/vijay/dinette-online/draft_order.php`;
  // let url = `https://app.dinetteonline.com/shopify/draft_order.php`;
  
  if(id){
    url = `https://dddemo.net/php/2025/vijay/dinette-online/draft_order.php?id=${id}`;
    // url = `https://app.dinetteonline.com/shopify/draft_order.php?id=${id}`;
  }
  fetch(url,data)
    .then((response) => {
      if (response.status) {
        console.log("success submitting -->",response);
        return response.json();
      } else {
        //console.log("Response Status: " + response.status);
      }
    })
    .then(result => {
      //console.log("Draft Result -->",result);
      if(result?.errors?.length){
        console.log("error processing to checkout -->");
        //show some error message
        return;
      } else if(result.data?.draftOrderUpdate?.draftOrder == null && result.data?.draftOrderUpdate?.userErrors?.length){
        //check if draft order is alredy created? if not then draft order id is not valid creat a new draft order using new request
        localStorage.setItem('draft_order_id',null);
        callDraftOrderAPI(null,data);
      } else if(result.data?.draftOrderUpdate?.draftOrder?.order?.confirmed){
        //check if draft order is alredy converted to real order? if yes then call draft order again wih empty id
        localStorage.setItem('draft_order_id',null);
        callDraftOrderAPI(null,data);
      } else {
        //draft order success
        let checkoutUrl = result.data?.draftOrderCreate?.draftOrder?.invoiceUrl || result.data?.draftOrderUpdate?.draftOrder?.invoiceUrl;
        let draftOrderId = result.data?.draftOrderCreate?.draftOrder?.id || result.data?.draftOrderUpdate?.draftOrder?.id;
        let currentLocale = Shopify?.locale;
        //console.log(`checkoutUrl >>`,checkoutUrl)
        let draftOrderIdSplit = draftOrderId.split('/DraftOrder/');
        localStorage.setItem('draft_order_id',draftOrderIdSplit[1]);
        location.href = `${checkoutUrl}${currentLocale ? `?locale=${currentLocale}`: ``}`; // redirect to checkout page with relevant locales
      }
    })
    .catch((err) => {
      console.error(`error >>`,err);
    });
}




});
// Ena ak custom code